import { Chip, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { TbLogin } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { userLoginStatuses } from "@/constants/UserLoginStatuses";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { User } from "@/types/user.types";

function RenderCell({ value }: { value: boolean }) {
    const status = userLoginStatuses.find((status) => status.value == value);
    return (
        <div className="flex items-center py-1 h-full">
            {status && (
                <NoMaxWidthTooltip
                    arrow
                    sx={{
                        [`& .${tooltipClasses.tooltip}`]: {
                            backgroundColor: "white",
                            border: "none",
                            padding: "0px !important",
                            fontSize: 12,
                            maxWidth: "200px !important",
                        },
                    }}
                    title={<HotelStatusTooltip status={status} />}
                >
                    <Chip
                        sx={{
                            backgroundColor: status.bg,
                            color: status.text,
                            fontWeight: 500,
                            fontSize: "12px !important",
                        }}
                        icon={createElement(status.component(), {
                            fontSize: 14,
                            color: status.text,
                        })}
                        label={status.label}
                    />
                </NoMaxWidthTooltip>
            )}
        </div>
    );
}

export const UserLoginStatusColumn = ({ t }: { t: TFunction }): GridColDef<User> => {
    return {
        field: "disabled",
        headerName: t("userLoginStatus"),
        minWidth: 180,
        valueGetter: (_val, row) => !!row.disabled,
        renderHeader: (params) => <TableHeader Component={TbLogin} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <RenderCell value={value} />,
    };
};
export default UserLoginStatusColumn;
